import { render, staticRenderFns } from "./ActivatePromoCode.vue?vue&type=template&id=6bc70a47&"
import script from "./ActivatePromoCode.vue?vue&type=script&lang=js&"
export * from "./ActivatePromoCode.vue?vue&type=script&lang=js&"
import style0 from "./ActivatePromoCode.vue?vue&type=style&index=0&id=6bc70a47&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports